import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export async function openBlob(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const u = URL.createObjectURL(r.data);
    if (filename) { const a = document.createElement("a"); a.href = u; a.download = filename; a.click(); }
    else window.open(u, "_blank");
    setTimeout(() => URL.revokeObjectURL(u), 15000);
  } catch (e) { toast.error(apiError(e)); }
}

export async function blobUrl(path) {
  const r = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}
